
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";

interface VisibilitySectionProps {
  visibility: "public" | "subscription";
  setVisibility: (visibility: "public" | "subscription") => void;
}

export const VisibilitySection = ({
  visibility,
  setVisibility,
}: VisibilitySectionProps) => {
  return (
    <div className="space-y-2">
      <Label>Recipe Visibility</Label>
      <RadioGroup
        value={visibility}
        onValueChange={(value) => setVisibility(value as "public" | "subscription")}
        className="flex flex-col space-y-1"
      >
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="public" id="public" />
          <Label htmlFor="public">Free Public Recipe</Label>
        </div>
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="subscription" id="subscription" />
          <Label htmlFor="subscription">Subscribers Only</Label>
        </div>
      </RadioGroup>
    </div>
  );
};
